import { AdvancedFilterPanel, type FilterField } from '@/components/common/AdvancedFilter';
import { useGeoCascade } from '@/hooks/useGeoCascade';
import { getFilterPanelProps, type UrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { getDateFromToFilterFields, getGeoFilterFields } from '@/utils/filterFields';
import { FILTER_KEYS, parseNumberFilter } from '@/utils/filters';

interface MpAreaFilterPanelProps {
  filters: UrlSyncedFilters;
  personField: FilterField;
  extraFields?: FilterField[] | undefined;
}

export function MpAreaFilterPanel({
  filters,
  personField,
  extraFields = [],
}: MpAreaFilterPanelProps) {
  const { filterValues } = filters;

  const geoOptions = useGeoCascade({
    divisionId: parseNumberFilter(filterValues[FILTER_KEYS.divisionId]),
    districtId: parseNumberFilter(filterValues[FILTER_KEYS.districtId]),
  });

  return (
    <AdvancedFilterPanel
      fields={[
        ...getDateFromToFilterFields(),
        personField,
        ...getGeoFilterFields(filterValues, geoOptions),
        ...extraFields,
      ]}
      {...getFilterPanelProps(filters)}
    />
  );
}
